import { Badge } from '@/components/ui/badge';
import { User } from 'lucide-react';

interface LinkedAccountBadgeProps {
  isOwner: boolean;
  className?: string;
}

export function LinkedAccountBadge({ isOwner, className }: LinkedAccountBadgeProps) {
  return (
    <Badge 
      variant={isOwner ? "default" : "secondary"} 
      className={`gap-1 ${className}`}
    >
      <User className="h-3 w-3" />
      {isOwner ? "Votre compte" : "Compte lié"}
    </Badge>
  );
}